import { Component, OnInit } from '@angular/core';
import { Global } from 'src/app/Service/global.service';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  styleUrls: ['./page404.component.scss']
})
export class Page404Component implements OnInit {
  langue = '';
  constructor(public global: Global) { }

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => { 
      this.langue = lg.code
    })

  }

}
